import { gql } from "@apollo/client";

export const GET_MOSQUES = gql`
  query GetMosques(
    $country: String!
    $prefectures: [String!]
    $limit: Int!
    $offset: Int!
  ) {
    mosques(
      country: $country
      prefectures: $prefectures
      limit: $limit
      offset: $offset
    ) {
      _id
      name
      location
      prefecture
      contact
      officialPageLink
    }
  }
`;

export const GET_PREFECTURES = gql`
  query GetPrefectures($country: String!) {
    getMosquesPrefectures(country: $country)
  }
`;
